module.exports = __webpack_public_path__ + "80d4eb69228133f72b5dcd7d0f9cb8e8.svg";